import { createClient } from '@supabase/supabase-js';

// Use the values from the Supabase integration
const SUPABASE_URL = "https://xluclmoyleytktrhtkeb.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhsdWNsbW95bGV5dGt0cmh0a2ViIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzYyMTYwNjUsImV4cCI6MjA1MTc5MjA2NX0.YXvKjOFpFTV_ZbkSpSB3M8uk8HfQtCn2swF0-C6c91c";

// Create a single instance
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    storageKey: 'app-supabase-auth'
  }
});